import React from "react";
import CustomPage from "../lib/Pages/Customizable";

export default function Home() {
  return <CustomPage slug={'home'} />;
}
